export enum RodzajSlownika {
    jednokolumnowy,
    wielokolumnowy
}